<template>
    <el-row class="data-card-list">
      <el-col
        class="data-card-item"
        :span="6"
        v-for="(chart, index) in chartList"
        :key="chart.type"
      >
        <ChartHeader
          :title="chart.title"
          :dayNum="chart.data.dayNum"
          :totalNum="chart.data.totalNum"
          :prefix="chart.prefix"
          :suffix="chart.suffix"
        />
        <TrendChart
          class="trend-chart"
          :values="chart.data.data"
          :type="chart.type"
          :title="chart.title"
          :key="`chart-${chart.type}`"
          :ref="`charts${index + 1}`"
        />
      </el-col>
    </el-row>
  </template>

<script>
import ChartHeader from './ChartHeader.vue';
import TrendChart from './trendChart.vue';

export default {
    name: 'TrendChartGroup',
    components: { ChartHeader, TrendChart },
    props: {
        chartList: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
};
</script>

  <style lang="scss" scoped>
  $borderColor: #1a47a4;

  .data-card-list {
    margin-top: 16px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
  }

  .data-card-item {
    padding: 10px 10px;
    margin-right: 16px;
    height: 35vh;
    min-height: 300px;
    max-height: 500px;
    border: 1px solid $borderColor;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    background-color: rgba(10, 20, 60, 0.3);

    &:last-child {
      margin-right: 0;
    }

    .trend-chart {
      height: 25vh !important;
    }
  }
  </style>
